<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <myNav :activeMynav="'order'"></myNav>
          <div class="bd">
              <div class="my-list">
                <el-table :data="list" style="width: 100%">
                  <el-table-column prop="orderNum" label="订单号" width="220px"></el-table-column>
                  <el-table-column prop="title" label="订单内容" width="300px"></el-table-column>
                  <el-table-column prop="price" label="实付金额">
                    <template slot-scope="scope">￥{{scope.row.price}}</template>
                  </el-table-column>
                  <el-table-column prop="form" label="类型"></el-table-column>
                  <el-table-column prop="time" label="订单日期"></el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination 
                  class="pagination" 
                  background 
                  layout="prev, pager, next" 
                  :page-size="length"
                  :total="totalNum"
                  hide-on-single-page
                  @current-change="changePage"
                >
                </el-pagination>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
import myNav from "@/components/my/myNav";
export default {
  components: {
    myLeft,
    myTop,
    myNav,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      length: 8,
      list: [],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getOrderList();
    },
    getOrderList(){
      let offset = (this.curPage-1)*this.length;
      this.$axios.api.request({
        url: "/api/qtclub/user/getOrderList",
        method: "GET",
        data: {
          offset: offset,
          length: this.length,
        }
      }, (res) => {
        this.list = res.data.list;
        this.totalNum = res.data.total;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.el-button{
  i{
    margin:0 5px 0 0;
  }
}
.my-box{
  .bd{
    padding: 20px;
    .my-list{
      ::v-deep .el-table{
        th{
          background:#f5f5f5;
        }
      }
    }
  }
}
</style>
